/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerMongoDBDestinationComponent', [
    '$rootScope',
    'DesignerBaseDatabaseDestinationComponent',

    function ($rootScope, DesignerBaseDatabaseDestinationComponent) {
      function DesignerMongoDBDestinationComponent() {
        DesignerBaseDatabaseDestinationComponent.apply(this);
      }

      DesignerMongoDBDestinationComponent.prototype = new DesignerBaseDatabaseDestinationComponent();

      DesignerMongoDBDestinationComponent.prototype.getData = function () {
        const data = DesignerBaseDatabaseDestinationComponent.prototype.getData.call(this);

        return data;
      };

      DesignerMongoDBDestinationComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerBaseDatabaseDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerMongoDBDestinationComponent.prototype.setData = function (data) {
        DesignerBaseDatabaseDestinationComponent.prototype.setData.call(this, data);
      };

      return DesignerMongoDBDestinationComponent;
    },
  ]);
})(window.angular);
